module.exports = __webpack_public_path__ + "img/supportIcon_Active.789562f3.png";